import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";
import { getProjectState } from "./utils";

function handleFailure(
  state: State,
  data: Boundaries["retrieveLists"]["failure"],
): State {
  const { index, result } = getProjectState(state, data);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...result,
          request: setRequestStateToFailure(),
          error: data.error,
          canRetrieveNextProjects: false,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          ...result,
          request: setRequestStateToFailure(),
          error: data.error,
          canRetrieveNextProjects: false,
        },
      ];
}

export { handleFailure };
